<div class="bars"></div>
<div class="scale-label">
  <span *ngIf="scaleLabel">{{ scaleLabel }}:</span> {{ zoomScale }}
</div>
